import { EnableSwitch, SelectUser } from '../..';

export const userSubscribeListItemForm = [
  {
    fields: [
      {
        field: 'subscribedForUserId',
        width: ['100%'],
        component: SelectUser,
        componentProps: {},
      },
      {
        field: 'status',
        component: EnableSwitch,
        width: ['100%'],
      },
    ],
  },
];
